import React, { useState } from "react";
import { X } from "lucide-react";
import PropTypes from "prop-types";

import { TEMPLATES } from "./constants";
import TemplatePreview from "./TemplatePreview";
import TemplateGrid from "./TemplateGrid";

export default function ThemeSelectionModal({
  isOpen,
  onClose,
  initialThemeIndex,
  initialTemplateId,
  onApply,
}) {
  const [selectedTemplateId, setSelectedTemplateId] = useState(
    initialTemplateId || "t1"
  );
  const [selectedThemeId] = useState(initialThemeIndex || 0);

  if (!isOpen) return null;

  const handleApply = () => {
    onApply({
      themeId: selectedThemeId,
      templateId: selectedTemplateId,
      mode: "templates",
    });
    onClose();
  };

  const selectedTemplate =
    TEMPLATES.find((t) => t.id === selectedTemplateId) || TEMPLATES[0];

  return (
    <div className="w-full h-full flex flex-col md:flex-row overflow-y-auto md:overflow-hidden relative font-sans">
      {/* Left Panel - Preview and Apply Button */}
      <div className="w-full md:w-[40%] bg-white p-6 lg:p-10 flex flex-col shrink-0 order-2 md:order-1">
        <div className="w-full h-full flex flex-col items-center">
          <TemplatePreview selectedTemplate={selectedTemplate} />

          <button
            onClick={handleApply}
            className="w-full mt-6 h-[40px] bg-[#1B5C29] text-white font-medium rounded-[8px] hover:bg-[#154421] transition shadow-sm text-base"
          >
            Apply
          </button>
        </div>
      </div>

      {/* Vertical Divider */}
      <div className="hidden md:block w-px h-[800px] bg-[#1B5C2940] self-center shrink-0 order-2" />

      {/* Right Panel - Template Selection */}
      <div className="flex-1 flex flex-col bg-white py-6 md:py-10 relative md:ml-[50px] order-1 md:order-3">
        <button
          onClick={onClose}
          className="absolute top-4 md:top-6 right-4 md:right-6 p-2 hover:bg-gray-100 rounded-full transition text-[#9CA3AF] hover:text-[#333333] z-10"
          aria-label="Close modal"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="mt-8 md:mt-[50px] mb-6 md:mb-8 px-4 md:px-0">
          <h2 className="text-[24px] leading-[34px] font-normal tracking-normal text-[#000]" style={{ fontFamily: "Helvetica" }}>
            Which template would you like to use?
          </h2>
        </div>

        <div className="px-4 md:px-0 pb-4 md:pb-0">
          <TemplateGrid
            templates={TEMPLATES}
            selectedTemplateId={selectedTemplateId}
            onSelect={setSelectedTemplateId}
          />
        </div>
      </div>
    </div>
  );
}

ThemeSelectionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  initialThemeIndex: PropTypes.number,
  initialTemplateId: PropTypes.string,
  onApply: PropTypes.func.isRequired,
};
